<template>
	<div class="mian_page">
		<div style="margin: 0 auto;width: 150px;height: 150px;"><img src="https://publicimge.oss-cn-hangzhou.aliyuncs.com/img/zhiwuhui_logo.jpg" style="width: 100%;height: 100%;" /></div>
		<div style="margin: 0 auto;width: 100px;height: 100px;"><img src="https://publicimge.oss-cn-hangzhou.aliyuncs.com/img/icon_duihao_01.png" style="width: 100%;height: 100%;" /></div>
		<div style="margin: 0 auto;width: 280px;height: 280px;text-align: center;margin-top: 30px;">感谢您的配合，我们的课程顾问将结合您的情况对您进行更有效的帮助！</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	beforeRouteLeave(to, from, next) {
		if (to.fullPath === '/') {
			return next();
		}
		if (to.name !== 'Index') {
			console.log('login?');
			next('/');
		} else {
			next(false);
		}
	},

	methods: {}
};
</script>

<style scoped>
.mian_page {
	width: 100%;
	height: 100vh;
	background-color: white !important;
}
</style>
